import alasql from 'alasql';

export function contenderList(data) {
  let result = alasql(`
    SEARCH / AS @club
      member_registrations / AS @member
      RETURN (
        @club->id AS [KlubbId],
        @club->club_name AS [KlubbNavn],
        @club->active_reg AS [active_reg],
        @member->id AS [PaameldingsId],
        @member->member_id AS [MedlemsId],
        @member->full_name AS [FulltNavn],
        @member->first_name AS [Fornavn],
        @member->last_name AS [Etternavn]
      )
    FROM ?
  `, [data]);
  result = alasql(`
    SELECT
      KlubbId,
      KlubbNavn,
      active_reg,
      CASE
        WHEN active_reg=true THEN 'Påmeldt'
        WHEN active_reg=false THEN 'Ikke Påmeldt'
      END AS AktivPaamelding,
      PaameldingsId,
      MedlemsId,
      FulltNavn,
      Fornavn,
      Etternavn
    FROM ?
  `, [result]);
  return result;
}



/** WEBPACK FOOTER **
 ** ./src/containers/events/reports/sql/contenders.js
 **/